<template>
  <section class="category__header" v-if="category">
    <Image :source="category.banner" class="category__header-image" priority v-reveal />
    <h1 class="title --main" v-reveal="{ delay: 200 }">{{ category.title }}</h1>
    <p class="category__header-description" v-reveal="{ delay: 250 }">{{ category.tagline }}</p>
    <div class="category__header-icon">
      <Icon id="category-arrow" class="category__header-arrow" v-reveal="{ delay: 400 }" />
      <Image :source="category.icon" priority v-reveal="{ delay: 300 }" />
    </div>
  </section>
</template>

<script>
import { Icon, Image } from '@/components/global'

export default {
  name: 'CategoryHeader',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  components: { Icon, Image },
}
</script>
